const translations = {
	NM_HTML_TITLE: 'Navigation',
};

export default translations;
